import wireframeVideoMenuIcon from '../assets/icons/wireframeVideoMenuIcon.svg';
import WireframeImage from './WireframeImage';

class WireframeVideo extends WireframeImage {
  constructor(fabricObject) {
    fabricObject.style ||= 'video';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframeVideoMenuIcon;
  }

  static externalName(): string {
    return 'Video';
  }
}

export default WireframeVideo;
